import React from 'react';
import type { PropAsset } from '../../../../propValues.types';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import ContentCarousel from './components/Carousel';
import { ValuePropTileShell } from './ValuePropTileShell';

type ValuePropCardProps = {
  data: PropAsset & { type: 'prop' };
  hideTilePrice?: boolean;
};

export const ValuePropCard = (props: ValuePropCardProps) => {
  const isMobile = useIsMobileScreen();
  const { data, hideTilePrice } = props;
  const contentList = data.contentList.filter(asset => asset.responsiveTarget === (isMobile ? 'mobile' : 'desktop'));

  if (!contentList.length) return null;

  return (
    <ValuePropTileShell
      row={data.row}
      column={data.column}
      columns={data.columns}
      hideTilePrice={hideTilePrice}
    >
      <ContentCarousel
        autoRotatePeriodMs={7500}
        content={contentList}
        {...data}
      />
    </ValuePropTileShell>
  );
};
